import PageHeader from "@/components/page-header";
import { HelpArticlePage } from "@/components/registrant/help/help-portal";
import ErrorComponent from "@/components/ui/error";
import {
  GOVERNMENT_HELP_PORTAL,
  getGovernmentHelpArticle,
  isGovernmentHelpArticleId,
} from "@/lib/government-help";
import { Link, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/government/help/$articleId")({
  component: GovernmentHelpArticle,
});

function GovernmentHelpArticle() {
  const { articleId } = Route.useParams();
  const article = isGovernmentHelpArticleId(articleId)
    ? getGovernmentHelpArticle(articleId)
    : undefined;

  if (!article) {
    return (
      <div className="flex w-full flex-col">
        <PageHeader title="Help Center" className="mb-6" />
        <ErrorComponent
          title="Help topic not found"
          message="That help article does not exist. Open the Help Center to browse topics."
        />
        <Link
          to="/government/help"
          className="text-primary mt-4 text-sm font-medium hover:underline"
        >
          All help topics
        </Link>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col">
      <PageHeader
        title="Help Center"
        subtitle={article.title}
        className="mb-6"
      />
      <HelpArticlePage article={article} catalog={GOVERNMENT_HELP_PORTAL} />
    </div>
  );
}
